import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAlert = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 13",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.25996 1.07068L1.19209 10.014C0.436568 11.3473 1.39968 13 2.93213 13H13.0679C14.6003 13 15.5634 11.3473 14.8079 10.014L9.74005 1.07068C8.97394 -0.281291 7.02608 -0.281289 6.25996 1.07068ZM8 9.00002C7.44772 9.00002 7 9.44773 7 10C7 10.5523 7.44772 11 8 11C8.55228 11 9 10.5523 9 10C9 9.44773 8.55228 9.00002 8 9.00002ZM7 4.00002C7 3.44773 7.44772 3.00002 8 3.00002C8.55228 3.00002 9 3.44773 9 4.00002V7.00002C9 7.5523 8.55228 8.00002 8 8.00002C7.44772 8.00002 7 7.5523 7 7.00002V4.00002Z"
	})
});
export default SvgAlert;
